import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL || "";

export default function PortalVerify() {
  const nav = useNavigate();
  const [error, setError] = useState("");
  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) { setError("Länk saknar token."); return; }
    (async () => {
      try {
        const res = await fetch(`${API}/api/portal/auth/verify`, {
          method: "POST", credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token }),
        });
        if (!res.ok) throw new Error((await res.json().catch(() => ({}))).detail || "Ogiltig länk");
        nav("/portal", { replace: true });
      } catch (e) { setError(e.message); }
    })();
  }, [nav]);
  return (
    <div className="min-h-screen bg-[#0e2a2f] flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl p-8 text-center max-w-sm" data-testid="portal-verify">
        {error ? (
          <>
            <p className="text-red-600 font-medium">{error}</p>
            <a href="/portal" className="text-[#255E69] text-sm mt-3 inline-block">Till inloggning</a>
          </>
        ) : (
          <div className="flex items-center gap-3 text-[#255E69]"><Loader2 className="w-5 h-5 animate-spin" /> Loggar in…</div>
        )}
      </div>
    </div>
  );
}
